import ExcelJS from 'exceljs/dist/exceljs.bare';
import { CellFormat, TabConfig } from '../excel.service.model';
import { Product } from '../../../product-center-table-wrapper/product-center-table-wrapper.model';
import { Constants } from '../excel-service.constants';
import { Constants as ProductCenterTableWrapperConstants } from '../../../product-center-table-wrapper/product-center-table-wrapper.constants';
import { formatDate } from '../excel-service.utils';
import { i18nService } from '../../../../common/i18n/i18n';

/**
 * Returns the configuration object for the price tab.
 * @param baseCurrency The base currency to be used in the headers.
 * @returns {TabConfig} The configuration object for the price tab.
 */
export async function getPriceConfig(
  baseCurrency: string,
  language: string,
): Promise<TabConfig> {
  if (!i18nService.isI18nLoadedForLanguage(language)) {
    await new Promise((resolve) => {
      i18nService.loadi18nForLanguage(language, resolve);
    });
  }

  const localize = i18nService.getFixedT(language, null, null);

  return {
    worksheetName: localize(
      ProductCenterTableWrapperConstants.TRANSLATION_KEYS.TABS.PRICE,
    ),
    fileName: `${localize(Constants.TRANSLATION_KEYS.FILE_NAME.PRICE)}.${Constants.EXCEL_FILE_EXTENSION}`,
    headers: [
      localize(Constants.TRANSLATION_KEYS.PRODUCT_RANGE),
      localize(Constants.TRANSLATION_KEYS.PRODUCT_NAME),
      localize(Constants.TRANSLATION_KEYS.CLASS),
      localize(Constants.TRANSLATION_KEYS.APIR),
      localize(Constants.TRANSLATION_KEYS.PRICE.NAV_PRICE, {
        baseCurrency,
      }),
      localize(Constants.TRANSLATION_KEYS.PRICE.APPLICATION_PRICE, {
        baseCurrency,
      }),
      localize(Constants.TRANSLATION_KEYS.PRICE.WITHDRAWAL_PRICE, {
        baseCurrency,
      }),
      localize(Constants.TRANSLATION_KEYS.PRICE.PRICE_AS_OF),
    ],
    columnWidths: Object.values(Constants.COLUMN_WIDTHS.PRICE),
    getRowData: (product: Product) => [
      product.productName.vehicleTypeName,
      product.productName.fundName,
      product.productName.shareClass,
      product.productName.apir,
      product.pricing?.navPrice,
      product.pricing?.applicationPrice,
      product.pricing?.withdrawalPrice,
      formatDate(product.pricing?.priceAsOfDate),
    ],
    cellFormatters: [
      { index: 5, format: CellFormat.CURRENCY },
      { index: 6, format: CellFormat.CURRENCY },
      { index: 4, format: CellFormat.CURRENCY },
    ],
    specialFormatting: (row: ExcelJS.Row) => {
      const alignment =
        row.getCell(8).value === Constants.HYPHEN
          ? Constants.ALIGNMENT.HORIZONTAL.LEFT
          : Constants.ALIGNMENT.HORIZONTAL.RIGHT;
      row.getCell(8).alignment = { horizontal: alignment };
    },
    renderFooterDisclaimers: false,
  };
}
